(() => {
  // ====== CONFIG ======
  const THRESHOLD_CENTS = 6000;           // 60,00 €
  const GIFT_VARIANT_ID = 52567182770440; // <-- tu variant_id numérico

  // ====== HELPERS ======
  const rootPath   = (window.Shopify?.routes?.root || '/');
  const isCartPage = () => location.pathname.replace(/\/+$/,'') === '/cart';

  async function getCart() {
    const r = await fetch(rootPath + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept':'application/json' }
    });
    return r.json();
  }

  function getGiftLines(cart) {
    return (cart.items || []).filter(i => i.variant_id === GIFT_VARIANT_ID);
  }

  // Subtotal que cuenta para el umbral (SIN el regalo)
  function getEligibleSubtotal(cart) {
    return (cart.items || []).reduce((sum, it) => {
      if (it.variant_id === GIFT_VARIANT_ID) return sum;
      return sum + (it.original_line_price || 0);
    }, 0);
  }

  // Cambia cantidad por KEY de línea (más fiable y rápido que /update)
  async function changeLineQty(lineKey, qty) {
    return fetch(rootPath + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: qty }),
      cache: 'no-store'
    });
  }

  // ============ UI: ocultado inmediato + overlay ============
  function findGiftDOMNodes() {
    const inputs = document.querySelectorAll(`.quantity__input[data-quantity-variant-id="${GIFT_VARIANT_ID}"]`);
    const rows = [];
    inputs.forEach(inp => {
      const row = inp.closest('.cart-item, tr, li');
      if (row && !rows.includes(row)) rows.push(row);
    });
    return rows;
  }

  // Oculta la(s) fila(s) del regalo instantáneamente (sin flicker)
  function hideGiftRowsInstant() {
    const rows = findGiftDOMNodes();
    rows.forEach(row => {
      row.classList.add('gift-pending-hide');
      row.style.display = 'none';
      row.style.pointerEvents = 'none';
      row.style.opacity = '';
    });
    return rows;
  }

  // Si algo fallase, desoculta
  function unhideGiftRows() {
    document.querySelectorAll('.gift-pending-hide').forEach(row => {
      row.classList.remove('gift-pending-hide');
      row.style.display = '';
      row.style.pointerEvents = '';
    });
  }

  // Overlay de “cargando” sobre toda la tabla del carrito
  function showCartBusy(flag) {
    const table = document.querySelector('table.cart-items');
    if (!table) return;

    // Asegura overlay
    let overlay = table.querySelector('.cart-table-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'cart-table-overlay hidden';
      overlay.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
          <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle>
        </svg>
      `;
      table.appendChild(overlay);
    }

    table.classList.toggle('is-busy', !!flag);
    overlay.classList.toggle('hidden', !flag);
    table.setAttribute('aria-busy', flag ? 'true' : 'false');
  }

  async function removeAllGifts(cart) {
    const gifts = getGiftLines(cart);
    for (const g of gifts) {
      await changeLineQty(g.key, 0);
    }
  }

  async function clampGiftQtyToOne(cart) {
    const gifts = getGiftLines(cart);
    let changed = false;
    for (const g of gifts) {
      if (g.quantity > 1) {
        await changeLineQty(g.key, 1);
        changed = true;
      }
    }
    return changed;
  }

  // ====== Limita max=1 visualmente ======
  function clampGiftInputs() {
    const sel = `.quantity__input[data-quantity-variant-id="${GIFT_VARIANT_ID}"]`;
    document.querySelectorAll(sel).forEach(inp => {
      inp.setAttribute('max', '1');
      if (parseInt(inp.value || '1', 10) > 1) inp.value = 1;
    });
  }

  // ====== BLINDAJE con ocultado optimista ======
  async function enforceGiftRules() {
    const cart = await getCart();
    const eligibleSubtotal = getEligibleSubtotal(cart);
    const giftLines = getGiftLines(cart);
    let fixed = false;

    if (giftLines.length && eligibleSubtotal < THRESHOLD_CENTS) {
      // Oculta al instante + overlay mientras Shopify procesa
      showCartBusy(true);
      hideGiftRowsInstant();
      try {
        await removeAllGifts(cart);
        fixed = true;
      } catch (e) {
        console.error('removeAllGifts failed', e);
        unhideGiftRows();
      } finally {
        showCartBusy(false);
      }
    } else if (giftLines.length) {
      const clamped = await clampGiftQtyToOne(cart);
      if (clamped) fixed = true;
    }

    return fixed;
  }

  // ====== EVENTOS / INTEGRACIÓN ======
  const debounced = (fn, ms = 60) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const react = debounced(async () => {
    const fixed = await enforceGiftRules();
    if (fixed && isCartPage()) location.reload();
    clampGiftInputs();
  }, 60);

  function wireUpListeners() {
    // Clics que suelen cambiar el carrito: reaccionamos muy rápido
    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!t) return;
      if (t.matches(
        '.quantity__button, .cart-remove-button, [name="remove"], [data-remove], [data-quantity], ' +
        'button, a[href*="/cart"]'
      )) {
        setTimeout(react, 40);
      }
    });

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t && (t.matches('input.quantity__input') || t.name === 'updates[]')) react();
    });

    document.addEventListener('input', (e) => {
      const t = e.target;
      if (t && t.classList?.contains('quantity__input') && +t.dataset.quantityVariantId === GIFT_VARIANT_ID) {
        if (parseInt(t.value || '1', 10) > 1) t.value = 1;
      }
    });

    [
      'cart:refresh','cart:change','cart:updated','page:loaded',
      'shopify:section:load','shopify:section:select','shopify:section:deselect',
      'shopify:section:reorder','shopify:block:select','shopify:block:deselect'
    ].forEach(evt => document.addEventListener(evt, react));

    // Observa re-renderes de tema
    const mo = new MutationObserver(debounced(() => {
      clampGiftInputs();
      react();
    }, 80));
    mo.observe(document.body, { childList: true, subtree: true });

    // Bloquea checkout si hay estado inválido (y limpia antes)
    const guardCheckoutButtons = (scope=document) => {
      scope.querySelectorAll('button[name="checkout"], form[action*="/checkout"] button[type="submit"]')
        .forEach((btn) => {
          btn.addEventListener('click', async (e) => {
            const fixed = await enforceGiftRules();
            if (fixed) {
              e.preventDefault();
              if (isCartPage()) location.reload();
            }
          }, { capture: true });
        });
    };
    guardCheckoutButtons(document);

    const guardMo = new MutationObserver(() => guardCheckoutButtons(document));
    guardMo.observe(document.body, { childList: true, subtree: true });
  }

  async function boot() {
    // Inyección de CSS para overlay/spinner (por si no lo pusiste en <head>)
    const style = document.createElement('style');
    style.textContent = `
      table.cart-items { position: relative; }
      table.cart-items.is-busy { opacity: 0.6; pointer-events: none; }
      .cart-table-overlay { position: absolute; inset: 0; display:flex; align-items:center; justify-content:center; background: rgba(255,255,255,0.55); z-index:5; }
      .cart-table-overlay.hidden { display: none; }
      .cart-table-overlay .spinner { width:44px; height:44px; animation: spin 1s linear infinite; }
      @keyframes spin { to { transform: rotate(360deg); } }
      .cart-table-overlay .path { stroke:#000; stroke-linecap:round; animation: dash 1.5s ease-in-out infinite; }
      @keyframes dash {
        0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
        50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
        100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; }
      }
    `;
    document.head.appendChild(style);

    wireUpListeners();

    clampGiftInputs();
    const fixed = await enforceGiftRules();
    if (fixed && isCartPage()) location.reload();

    // Polling corto de arranque para cubrir apps/temas que actualizan con retraso
    let tries = 0;
    const poll = setInterval(async () => {
      tries++;
      const fixed = await enforceGiftRules();
      clampGiftInputs();
      if (fixed && isCartPage()) location.reload();
      if (tries >= 6) clearInterval(poll); // ~1.2-1.5s
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', () => {
    clampGiftInputs();
    react();
  });
})();